// Origen del backend FastAPI. Se inyecta en tiempo de build:
//   local   → .env  (REACT_APP_API_URL=http://localhost:8000)
//   dev     → variable de entorno de la rama develop en Amplify
//   prod    → variable de entorno de la rama main en Amplify
// Se quita la barra final para que no se generen rutas con doble slash.
export const API_ROOT = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/+$/, '');
